import React, { useEffect, useState } from "react";
import moment from "moment";

interface AgeLiveProps {
  createdAt: string | number | Date;
}

const AgeLive: React.FC<AgeLiveProps> = ({ createdAt }) => {
  const [timeAgo, setTimeAgo] = useState<string>("");

  useEffect(() => {
    const updateAge = () => {
      const duration = moment.duration(moment().diff(moment(createdAt)));

      const days = Math.floor(duration.asDays());
      const hours = Math.floor(duration.asHours()) % 24;
      const minutes = Math.floor(duration.asMinutes()) % 60;
      const seconds = Math.floor(duration.asSeconds()) % 60;

      let formattedAge = "";
      if (days > 0) formattedAge += `${days} day${days > 1 ? "s" : ""} `;
      if (hours > 0) formattedAge += `${hours} hr${hours > 1 ? "s" : ""} `;
      if (minutes > 0) formattedAge += `${minutes} min${minutes > 1 ? "s" : ""} `;
      if (seconds >= 0) formattedAge += `${seconds} sec${seconds !== 1 ? "s" : ""} `;

      setTimeAgo(formattedAge.trim() + " ago");
    };

    updateAge(); // Initial call
    const interval = setInterval(updateAge, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [createdAt]);

  return <div>{timeAgo}</div>;
};

export default AgeLive;
